import { AuthEndpoints } from './auth'
import { ProfileEndpoints } from './profile'
import { PlansEndpoints } from './plans'
import { BugReport } from './reports'
import { AppSettingsEndpoints } from './app-settings'
import { CountryEndpoints } from './countries'
import { AvatarsEndpoints } from './avatars'
import { CourseEndpoints } from './courses'
import { CommentsEndPoint } from './comment'
import { LanguageEndpoints } from './languages'
import { PaymentEndpoints } from './payment'
import { UserEndpoints } from './user'
import { ExamEndpoint } from './exam'
import { FileSystemEndpoints } from './file'
import { ChatIntelligenceEndpoints } from './chat-intelligence'
import { PlacementEndpoints } from './placement'
import { VocabularyEndpoints } from './vocabulary'
import { AdvertisementEndpoints } from './advertisement'
import { ClassesEndpoints } from './classes'
import { NotificationEndpoints } from './notifications'
import { TeacherEndpoints } from './teachers'
import { StoryEndpoints } from './stories'

export const ENDPOINTS = {
  Stories: StoryEndpoints,
  Teachers: TeacherEndpoints,
  Auth: AuthEndpoints,
  Advertise: AdvertisementEndpoints,
  Classes: ClassesEndpoints,
  Notifications: NotificationEndpoints,
  Profile: ProfileEndpoints,
  Plans: PlansEndpoints,
  BugReport,
  Settings: AppSettingsEndpoints,
  Country: CountryEndpoints,
  Avatars: AvatarsEndpoints,
  Course: CourseEndpoints,
  Comments: CommentsEndPoint,
  Payment: PaymentEndpoints,
  Languages: LanguageEndpoints,
  User: UserEndpoints,
  exam: ExamEndpoint,
  file: FileSystemEndpoints,
  ChatIntelligence: ChatIntelligenceEndpoints,
  Placement: PlacementEndpoints,
  Vocabulary: VocabularyEndpoints
}
